import { ApolloAuth0AuthenticatedProvider } from "src/api/ApolloAuthenticatedProvider"
import { MessageBrokerProvider } from "src/global/messageBroker/provider"

interface AppProvidersProps {
  children: React.ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ApolloAuth0AuthenticatedProvider>
      <MessageBrokerProvider>{children}</MessageBrokerProvider>
    </ApolloAuth0AuthenticatedProvider>
  )
}
